import ApiClient from './ApiClient';

class AccountAccessTokensAPI extends ApiClient {
  constructor() {
    super('integrations/developer_api/access_tokens', { accountScoped: true });
  }
}

export default new AccountAccessTokensAPI();
